<template>
    <div class="page_container">
<!--        <van-button @click="showPay = !showPay">点击</van-button>-->
        <div class="recharge_role_container">
            <span>充值区服 / 角色：{{ rechargeServer}} / {{rechargeRoleName }}</span>
        </div>
        <div class="main_container">
            <div style="font-size: 16px;margin-left: 5px;font-weight: bold">选择充值金额</div>
            <div class="recharge_grid">
                <div v-for="item in rechargeData" :ref="item.price+''" class="recharge_grid_child_box" @click="selectFixedAmount(item.price)">
                    <span>{{ item.name }}.00</span>
                    <span class="badge" v-show="item.price === active">
                        <img src="../../assets/yes.png" width="20" height="20"/>
                    </span>
                </div>
                <div class="recharge_grid_child_box custom_recharge_box" @click="selectFixedAmount(0)">
                    <span class="custom_recharge_symbol">¥</span>
                    <input v-model="inputAmount" ref="customInput" @input="handelInput" @blur="handelBlur" placeholder="其他金额" maxlength="4" style="width: 95%;height: 40px;font-size:18px;margin-left: 1px;"/>
                    <span class="badge" v-show="0 === active">
                        <img src="../../assets/yes.png" width="20" height="20"/>
                    </span>
                </div>
            </div>
            <div class="pay_mode_container">
                <div class="pay_mode_box" @click="selectPayMode(22)">
                    <img src="../../assets/pay_wx.png">
                    <span>微信</span>
<!--                    <img v-show="selectWeChatPay" src="../../assets/selected_jb.png" width="54" height="54" style="position:relative;left:4px;bottom: 4px;transform: rotate(90deg);">-->
                    <span class="badge" v-show="selectWeChatPay">
                        <img src="../../assets/yes.png" width="20" height="20"/>
                    </span>
                </div>
                <div class="pay_mode_box" @click="selectPayMode(32)">
                    <img src="../../assets/pay_zfb.png">
                    <span>支付宝</span>
<!--                    <img v-show="selectAlipay" src="../../assets/selected_jb.png" width="54" height="54" style="position:relative;left:4px;bottom: 4px;transform: rotate(90deg);">-->
                    <span class="badge" v-show="selectAlipay">
                        <img src="../../assets/yes.png" width="20" height="20"/>
                    </span>
                </div>
            </div>
            <div class="pay_button" @click="onSubmit">
                支付{{ inputAmount ? inputAmount : selectAmount }}.00元
            </div>
            <div v-show="showPay" class="pay_container">
                <div class="pay_title">
                    请使用{{ payName }}扫码支付
                </div>
                <div class="pay_qr_code">
                    <img v-show="!showQr" src="../../assets/scan_code_img.png" style="width: 100%;height: 100%"/>
                    <div v-if="showQr && selectWeChatPay" ref="qrCode"></div>
                    <iframe v-if="showQr && selectAlipay" style="width: 205px;height: 205px;transform: scale(0.68)"
                            :src="payUrl"></iframe>
                    <div v-show="hideRegainQr || hideLoadingQr" class="qr_overlay">
                        <div v-show="hideRegainQr" class="flex_center" style="flex-direction: column;cursor: pointer;">
                            <van-icon name="replay" size="50" color="#fff"/>
                            <div style="font-size:14px;color: #fff;">订单已过期,请重新下单</div>
                        </div>
                        <van-loading v-show="hideLoadingQr" type="spinner" size="50" />
                    </div>
                </div>
            </div>
<!--            <div class="recharge_agreement">-->
<!--                《充值协议》-->
<!--            </div>-->
            <div class="gzh_box">
                <img src="../../assets/gzh.jpg" style="width: 70%;"/>
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div>如有疑问</div>
                    <div>请关注公众号联系客服</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Dialog, Toast} from "vant";
import {request} from "@/api/request";
import QRCode from "qrcodejs2";
import {md5} from "@/utils/md5";

export default {
    name: "BXCQPay",
    data() {
        return {
            showPay: false,
            payName: "微信",
            rechargeRoleName: "",
            rechargeServer: "",
            rechargeType: "",
            inputAmount: "",
            selectAmount: "100",
            active: 100,
            selectWeChatPay: true,
            selectAlipay: false,
            payMode: 22,
            rechargeData: [
                {
                    name: "¥100",
                    price: 100
                },
                {
                    name: "¥500",
                    price: 500
                },
                {
                    name: "¥1000",
                    price: 1000
                },
                {
                    name: "¥2000",
                    price: 2000
                },
                {
                    name: "¥5000",
                    price: 5000
                },
            ],
            hideRegainQr: false,
            hideLoadingQr: false,
            qrCode: "",
            showQr: false,
            timer: "",
            payUrl: "",
        }
    },
    mounted() {
        this.rechargeRoleName = this.$route.query.name;
        this.rechargeServer = this.$route.query.server;
        this.rechargeType = this.$route.query.t;
    },
    methods: {
        onSubmit() {
            let amount = 0;
            if(this.active <= 0) {
                // let inputAmount = parseInt(this.inputAmount);
                let inputAmount = parseFloat(this.inputAmount);
                if(inputAmount < 10) {
                    Toast("充值金额不能小于10元");
                    return;
                }
                if(inputAmount > 5000) {
                    Toast("充值金额不能大于5000元");
                    return;
                }
                amount = inputAmount;
            }else {
                amount = this.active;
            }

            this.showPay = true;
            this.showQr = true;
            if(this.hideRegainQr) {
                this.hideRegainQr = false;
            }
            this.hideLoadingQr = true;
            let options = {
                url: "/open/order/bxOrder",
                method: "POST",
                data: {
                    money: amount,
                    paymentType: this.payMode,
                    roleName: this.rechargeRoleName,
                    serverName: this.rechargeServer,
                    serverId: this.rechargeType,
                }
            }
            request(options).then(res => {
                if (res.data.success) {
                    this.payUrl = res.data.data.payString
                    if(this.selectWeChatPay) {
                        this.qrCode = new QRCode(this.$refs.qrCode, {
                            text: this.payUrl,
                            width: 150,
                            height: 150,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            correctLevel: 3
                        });
                    }
                    this.hideLoadingQr = false;
                    this.timer = setInterval(() => this.getPayStatus(res.data.data.orderId), 2000)
                }else {
                    Toast(res.data.error.message);
                }
            })
        },
        getPayStatus(orderId) {
            let options = {
                url: "/open/queryPayCodeStatus",
                method: 'post',
                data: {
                    orderId: orderId,
                    userId: -1,
                }
            };
            request(options).then(res => {
                if (res.data.success) {
                    let code = res.data.data;
                    if (code === 1) {//待支付，继续请求

                    }
                    else if (code === 0) {//已过期
                        this.expired();
                        Toast('订单已过期，如要支付请重新下单');
                    }
                    else if (code === 2) {//已支付，关闭窗口
                        Dialog.alert({
                            message: '充值成功，请到游戏内领取',
                            confirmButtonColor: '#7a69be'
                        }).then(() => {
                        });
                        this.closePay();
                        Toast('订单支付成功');
                    }
                }
                else {
                    this.closePay();
                    Toast(res.data.error.message);
                }
            });
        },
        closePay() {
            this.hideRegainQr = false;
            this.hideLoadingQr = false;
            this.showQr = false;
            this.payUrl = "";
            clearInterval(this.timer);
        },
        expired() {
            this.hideRegainQr = true;
            this.hideLoadingQr = false;
            this.showQr = false;
            this.payUrl = "";
            clearInterval(this.timer);
        },
        selectFixedAmount(price) {
            if(price !== 0) {
                this.selectAmount = price;
                this.inputAmount = "";
            }else {
                this.$refs.customInput.focus();
            }
            this.active = price;
        },
        selectPayMode(payMode) {
            this.payMode = payMode;
            switch (payMode) {
                case 22:
                    this.payName = "微信";
                    this.selectWeChatPay = true;
                    this.selectAlipay = false;
                    break;
                case 32:
                    this.payName = "支付宝";
                    this.selectWeChatPay = false;
                    this.selectAlipay = true;
                    break;
            }
        },
        handelInput(e) {
            let inputAmount = this.inputAmount;
            if(!inputAmount) {
                return;
            }
            if(!/^[1-9]\d*$/.test(inputAmount) > 5000) {
                Toast("充值金额不能大于5000元")
                this.inputAmount = "5000";
                return;
            }
        },
        handelBlur() {
            if(!this.inputAmount) {
                return;
            }
            if(parseFloat(this.inputAmount) < 10) {
                Toast("充值金额不能小于10元");
                this.inputAmount = "10";
            }
        }
    }
}
</script>

<style scoped>
.page_container{
    width: 100vw;
    height: 100vh;
    background-color: #f2f2f2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    user-select: none;
    position: relative;
}
.recharge_role_container {
    min-width: 363px;
    min-height: 40px;
    width: 30%;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(var(--hover-color), #fff);
    padding: 10px;
    text-align: left;
    border-radius: 8px 8px 0 0;

    font-size: 18px;
}
.main_container {
    position: relative;
    min-width: 363px;
    min-height: 595px;
    width: 30%;
    height: 70%;
    border: 1px solid #eee;
    border-top: 0;
    border-radius: 0 0 8px 8px;
    background-color: #fff;
    text-align: left;
    padding: 0 10px 10px 10px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
}
.pay_container {
    //background-color: #0e7dde;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
}
.pay_title {
    font-size: 18px;
    font-weight: 600;
    //margin-top: 100px;
}
.pay_qr_code {
    width: 26%;
    //height: 70%;
    min-width: 125px;
    min-height: 125px;
    border: 1px solid #ddd;
    border-radius: 8px;
    position: relative;
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}
.qr_overlay {
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(49, 49, 49, 0.9);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.recharge_grid {
    display: grid;
    grid-template-rows:repeat(2,1fr);
    grid-template-columns: repeat(3,1fr);
    justify-items: center;
    row-gap: 10px;
    //margin-top: 15px;
}
.badge {
    position: absolute;
    top: -1px;
    right: -1px;
    width: 50px;
    height: 50px;
    clip-path: polygon(0 0, 100% 0, 100% 100%); /* 右上角三角形 */
    overflow: hidden;
    background-color: var(--normal-color);
    border-top-right-radius: 8px;
}
.badge img {
    //width: 100%;
    //height: 100%;
    object-fit: cover;
    position: absolute;
    top: 3px;
    right: 5px;
}
.recharge_grid_child_box {
    width: 95%;
    height: 112px;
    line-height: 112px;
    border: 1px solid #ddd;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    font-weight: 600;
    font-size: 20px;
    color: var(--normal-color);
    transition: all 0.3s ease;
    position: relative;
}
.recharge_grid_child_box:hover,.pay_mode_box:hover {
    border-color: var(--hover-color);
}
.recharge_grid_child_box:active {
    //background-color: var(--active-color);
    transform: scale(0.98);
}
.recharge_grid_child_box input{
    border: 0;
}
.pay_mode_container {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    column-gap: 10px;
    //margin-top: 15px;
}
.pay_mode_box {
    position: relative;
    height: 54px;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding-left: 10px;
    display: grid;
    grid-template-columns: 50px 1fr 54px;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
}
.pay_mode_box:active {
    transform: scale(0.98);
}
.pay_mode_box span {
    padding-left: 5px;
    font-size: 18px;
    font-weight: 600;
}
.pay_button {
    background: rgba(124, 107, 192, 0.6);
    border-radius: 3px;
    //margin-top: 15px;
    padding: 10px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
}
.pay_button:active {
    transform: scale(0.98);
}
.recharge_agreement {
    font-size: 13px;
    color: #2d9eef;
    position: absolute;
    bottom: 5px;
    left: calc(50% - 39px);
    cursor: pointer;
}
.recharge_agreement:active {
    transform: scale(0.98);
}
.custom_recharge_box {
    display: flex;
    align-items: center;
}
.custom_recharge_symbol {
    margin-left: 29%;
    transition: all 0.3s ease;
}

.gzh_box {
    width: 140px;
    height: 140px;
    background-color: #fff;
    transition: all 0.3s ease;
    position: absolute;
    top: 40px;
    right: -140px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.flex_center {
    display: flex;
    align-items: center;
    justify-content: center;
}
@media screen and (max-width: 1440px) {
    .custom_recharge_symbol {
        margin-left: 20%;
    }
}

@media screen and (max-width: 1220px) {
    .custom_recharge_symbol {
        margin-left: 10px;
    }
}
@media screen and (max-width: 910px) {
    .gzh_box {
        display: none;
    }
}
</style>